import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { putRequest } from 'src/utils/request';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import messages from '../../messages';
import { TutorialQuestionParamsType } from './useCreateTutorialQuestion';
import { buildSaveTutorialQuestionParams } from './useCreateTutorialQuestion';

type UpdateTutorialQuestionParamsType = TutorialQuestionParamsType & {
  questionUuid: string;
};

const updateTutorialQuestion = async (
  question: UpdateTutorialQuestionParamsType,
) => {
  const { data } = await putRequest<RequestSimplifiedData>(
    API.PUT.updateTutorialQuestion(question.questionUuid),
    buildSaveTutorialQuestionParams(question),
  );
  return data;
};

export const useUpdateTutorialQuestion = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateTutorialQuestion,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.tutorialQuestionSaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIAL_QUESTIONS] });
    },
    onError: handleError,
  });
};
